import React, {useEffect} from 'react';
import TemplateInformPage from "../../../../Components/TemplateInformPage";
import {Localization} from "../../../../Common/Localization";
import { ReactComponent as SuccessIcon} from "../../../../Resources/check-contained.svg";
import {config} from "../../../../Config/Config";

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    },
    alignCenter: {
        alignSelf: 'center'
    }
};


function EmailVerificationSuccessPage() {
    let iconStroke = config.theme.iconColor || "#368FBB";
    let iconFill= config.theme.iconFill || "#EBF4F8";
    useEffect(() => {
        iconStroke = config.theme.iconColor;
        iconFill = config.theme.iconFill;
    }, [config.theme.iconColor, config.theme.iconFill]);
  return (
      <div style={{...styles.container}}>
          <div style={{...styles.alignCenter}}>
              <SuccessIcon  fill={iconFill}  stroke ={iconStroke} />
          </div>
        <TemplateInformPage
            title={Localization.VERIFY_PAGE.SUCCESS.TITLE}
            text={Localization.VERIFY_PAGE.SUCCESS.MESSAGE}
            subText={Localization.VERIFY_PAGE.SUCCESS.SUB_MESSAGE}
        />
          <div style={{height: 50}}></div>

      </div>
  );
}

export default EmailVerificationSuccessPage;
